<kendo-dialog-titlebar>
    Indirect Service</kendo-dialog-titlebar>
<section class="k-mb-xl">
    <kendo-buttongroup selection="single">
        <button kendoButton [toggleable]="true" fillMode="outline" themeColor="dark" [selected]="isScheduledTab"
            (click)="selectTab('scheduled')">Scheduled</button>
        <button kendoButton [toggleable]="true" fillMode="outline" themeColor="dark" [selected]="!isScheduledTab"
            (click)="selectTab('actual')">Actual</button>
    </kendo-buttongroup>
</section>
<form [formGroup]="indirectServiceForm">
    <section class="k-d-grid k-gap-y-xl">
        <div class="k-d-flex k-gap-xl k-align-items-center">
            <kendo-svg-icon [icon]="chalkBordUser" size="medium"></kendo-svg-icon>
            <kendo-formfield class="k-w-full">
                <kendo-label text="Session Type" labelCssClass="hidden-label">
                    <kendo-dropdownlist placeholder='Session Type' [valueField]="'id'" [data]="sessionTypes"
                        [readonly]="true" [textField]="'description'"
                        formControlName="sessionType"></kendo-dropdownlist>
                </kendo-label>
            </kendo-formfield>
        </div>
        @if (showTraining) {
        <div class=" k-ml-10">
            <kendo-formfield class="k-w-full">
                <kendo-label text="Training Description" labelCssClass="hidden-label">
                    <kendo-textbox placeholder="Training Description" formControlName="trainingDescription"
                        [readonly]="isScheduledTab || viewMode">
                    </kendo-textbox>
                </kendo-label>
            </kendo-formfield>
        </div>
        }
    </section>
    <span class="k-form-separator !k-my-8"></span>
    <section class="k-d-grid k-gap-y-xl">
        <div class="k-d-flex k-gap-xl k-align-items-center">
            <kendo-svg-icon [icon]="clock" size="medium"></kendo-svg-icon>
            <div class="k-d-flex k-gap-x-sm k-align-items-center ">
                <kendo-formfield [style.width.px]="160">
                    <kendo-label text="Start Date" labelCssClass="hidden-label">
                        <kendo-datepicker calendarType="classic" placeholder="Start Date"
                            [readonly]="isScheduledTab || viewMode" formControlName="startDate"></kendo-datepicker>
                    </kendo-label>

                </kendo-formfield>
            </div>

            <kendo-formfield [style.width.px]="140">
                <kendo-label text="Start Time" labelCssClass="hidden-label">
                    <kendo-timepicker placeholder="Start Time" formControlName="startTime"
                        [readonly]="isScheduledTab || viewMode" [min]="isScheduledTab ? minTime : null"
                        [max]="isScheduledTab ? maxTime : null"
                        [class.k-invalid]="hasInvalidTimeRange"></kendo-timepicker>
                </kendo-label>
            </kendo-formfield>
            <span class="k-d-flex k-align-items-center">to</span>
            <kendo-formfield [style.width.px]="140">
                <kendo-label text="End Time" labelCssClass="hidden-label">
                    <kendo-timepicker placeholder="End Time" formControlName="endTime"
                        [readonly]="isScheduledTab || viewMode" [min]="isScheduledTab ? minTime : null"
                        [max]="isScheduledTab ? maxTime : null"
                        [class.k-invalid]="hasInvalidTimeRange"></kendo-timepicker>
                </kendo-label>
            </kendo-formfield>
            <span class="k-d-flex k-align-items-center">{{ durationLabel }}</span>
        </div>
        <!----------Participants-------->
        <div class="k-d-flex k-gap-xl k-align-items-start">
            <kendo-svg-icon [icon]="users" size="medium">
            </kendo-svg-icon>

            <div class="k-d-grid k-gap-y-md k-flex-1">
                @if (showStudents) {
                    @if(indirectServiceForm.get('sessionType')?.value?.id === sessionTypeEnum.IEPMeetingAttendance){
                       <kendo-formfield class="k-w-full">
                        <kendo-label text="Students" labelCssClass="hidden-label">
                            <kendo-combobox #list [data]="studentsList" formControlName="students" [kendoDropDownFilter]="filterSettings"

                                textField="studentName" [filterable]="true" valueField="studentSK">

                                <ng-template kendoComboBoxItemTemplate let-dataItem>
                                    <span>{{ dataItem?.studentName }}</span>
                                </ng-template>
                                <ng-template kendoComboBoxNoDataTemplate>
                                    <span>No students found</span>
                                </ng-template>
                                <ng-template kendoPrefixTemplate>
                                    <button type="button" kendoButton
                                        class="k-button k-button-solid k-button-solid-base" [disabled]="true">
                                        Students
                                    </button>
                                </ng-template>
                            </kendo-combobox>
                        </kendo-label>

                    </kendo-formfield>
                    }@else{
                <kendo-formfield class="k-w-full">
                    <kendo-label text="Students" labelCssClass="hidden-label">
                        <kendo-multiselect placeholder="Students" formControlName="students"
                            [data]="indirectServiceForm.get('students')?.value || []" [allowCustom]="true"
                            [readonly]="isScheduledTab || viewMode"
                            [valueField]="'studentSK'">
                            <ng-template kendoPrefixTemplate>
                                <button kendoButton [disabled]="true">Students</button>
                            </ng-template>
                            <ng-template kendoMultiSelectTagTemplate let-dataItem>
                                <span class="template">{{ dataItem.name ?? dataItem?.studentName }}</span>
                            </ng-template>
                              <ng-template kendoMultiSelectItemTemplate let-dataItem>
                                <span>{{ dataItem.name ?? dataItem?.studentName }}</span>
                              </ng-template>
                        </kendo-multiselect>
                    </kendo-label>
                </kendo-formfield>
                    }
                }
                @if (showParticipantsAndLocation) {
                <kendo-formfield class="k-w-full">
                    <kendo-label text="Required Attendees" labelCssClass="hidden-label">
                        <kendo-multiselect placeholder="Required Attendees" [data]="attendeeList"
                            [valuePrimitive]="true" [allowCustom]="true" [readonly]="isScheduledTab || viewMode"
                            formControlName="requiredAttendees">
                            <ng-template kendoPrefixTemplate>
                                <button kendoButton [disabled]="true">Required Attendees</button>
                            </ng-template>
                            <ng-template kendoMultiSelectTagTemplate let-dataItem>
                                <span class="template">{{dataItem }}</span>
                            </ng-template>
                        </kendo-multiselect>
                    </kendo-label>
                </kendo-formfield>
                }
                @if (showParticipantsAndLocation) {
                <kendo-formfield class="k-w-full">
                    <kendo-label text="Optional Attendees" labelCssClass="hidden-label">
                        <kendo-multiselect placeholder="Optional Attendees" [data]="attendeeList"
                            [valuePrimitive]="true" [allowCustom]="true" [readonly]="isScheduledTab || viewMode"
                            formControlName="optionalAttendees">
                            <ng-template kendoPrefixTemplate>
                                <button kendoButton [disabled]="true">Optional Attendees</button>
                            </ng-template>
                            <ng-template kendoMultiSelectTagTemplate let-dataItem>
                                <span class="template">{{ dataItem }}</span>
                            </ng-template>
                        </kendo-multiselect>
                    </kendo-label>
                </kendo-formfield>
                }
            </div>
        </div>
        <!------------Location---------------->
        @if (showParticipantsAndLocation) {
        <div class="k-d-flex k-gap-xl k-align-items-center k-flex-1">
            <kendo-svg-icon [icon]="locationDot" size="medium"></kendo-svg-icon>

            <div class="k-d-flex k-gap-x-sm k-align-items-center k-flex-1 k-w-full">
                <kendo-formfield [style.width.px]="160">
                    <kendo-label text="Location Type" labelCssClass="hidden-label">
                        <kendo-dropdownlist [data]="referenceStore.scheduleLocationType$ | async" [valueField]="'id'"
                            [readonly]="isScheduledTab || viewMode" formControlName="locationType"
                            [textField]="'description'"></kendo-dropdownlist>
                    </kendo-label>
                </kendo-formfield>

                <kendo-formfield class="k-flex-1">
                    <kendo-label text="Location" labelCssClass="hidden-label">
                        <kendo-textbox placeholder="Location" formControlName="location"
                            [readonly]="isScheduledTab || viewMode"></kendo-textbox>
                    </kendo-label>
                </kendo-formfield>

                <kendo-svg-icon [icon]="stairs" size="medium" class="k-flex-none"></kendo-svg-icon>

                <kendo-formfield [style.width.px]="263">
                    <kendo-label text="Floor/Room" labelCssClass="hidden-label">
                        <kendo-textbox placeholder="Floor/Room" formControlName="floorRoom"
                            [readonly]="isScheduledTab || viewMode"></kendo-textbox>
                    </kendo-label>
                </kendo-formfield>
            </div>
        </div>
        }

        <!----------Teams Meeting Switch------->
       @if (showParticipantsAndLocation) {
        <div class="k-d-flex k-gap-x-sm k-ml-10">
            <kendo-formfield>
                <div class="k-d-flex k-gap-lg">
                    <kendo-label text="Teams Meeting / Tele">
                    </kendo-label>
                    <kendo-switch formControlName="teamsMeeting" [readonly]="isScheduledTab || viewMode"></kendo-switch>
                </div>
            </kendo-formfield>
        </div>
        }
        <div class="k-d-flex k-gap-xl k-align-items-center">
            <kendo-svg-icon [icon]="indent"></kendo-svg-icon>
            <kendo-formfield class="k-w-full k-mt-4">
                <kendo-label text="Additional Information">
                    <kendo-textarea [rows]="3" placeholder="Type here" [readonly]="isScheduledTab || viewMode"
                        formControlName="additionalInfo"></kendo-textarea>
                </kendo-label>
            </kendo-formfield>
        </div>
    </section>
</form>
<kendo-dialog-actions>
    <button kendoButton themeColor="primary" [disabled]="isScheduledTab || hasInvalidTimeRange"
        (click)="submitCertify()" *ngIf="!viewMode">Submit and
        Certify</button>
</kendo-dialog-actions>